import { render, staticRenderFns } from "./ClientVisits.vue?vue&type=template&id=16d81ed7"
import script from "./ClientVisits.vue?vue&type=script&lang=js"
export * from "./ClientVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports